import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../ui/kit.js';
import './import.css';

/**
 * What playing a YouTube video on the tablet actually means.
 *
 * Required by `SPEC.md` §11.3, and required *here* — at the point of adding,
 * not in a settings page nobody opens. Three things have to be said, and the
 * product owner accepted all three rather than pretending they were solvable:
 *
 * - it plays in YouTube's own player,
 * - that player carries YouTube's branding and may show advertising,
 * - and from inside it a child can reach YouTube itself.
 *
 * The third is the one that costs something. Nothing else in this product
 * offers a way out, and §11.2 sets out why no amount of careful design closes
 * it. Covering the branding or blocking the exit is what would breach YouTube's
 * terms; accepting them is what keeps the product compliant. A parent who wants
 * an environment with no way out can build one from their own files, and this
 * says so rather than leaving them to work it out.
 *
 * Shown, not acknowledged. §11.3 requires the parent to be told, and a tick-box
 * gate would add friction on every single add while measuring nothing — people
 * tick past those. What it must never become is a line in a settings page, nor
 * folded behind an info control the way ordinary explanations are.
 */
export const YouTubeDisclosure = () => {
  const { t } = useTranslation();
  const titleId = useId();

  return (
    <section className="yt-disclosure" aria-labelledby={titleId}>
      <h3 id={titleId} className="yt-disclosure-title">
        <Icon name="info" small />
        {t('youtube.disclosureTitle')}
      </h3>

      <ul className="yt-disclosure-list">
        <li>{t('youtube.disclosurePlayer')}</li>
        <li>{t('youtube.disclosureAdvertising')}</li>
        <li>{t('youtube.disclosureExit')}</li>
      </ul>

      <p className="yt-disclosure-alternative">{t('youtube.disclosureAlternative')}</p>
    </section>
  );
};
